import React, { useEffect, useState } from 'react'
// import { MdOutlineCancel } from 'react-icons/md'
import './TagContainer.css'
import { Auth } from 'aws-amplify'
import CreateTagService from '../../Services/Queries/CreateTagService'
import MoreInputs from './MoreInputs'
import { toast } from 'react-toastify'
import { ToastStyle } from '../Data/MovieStaticData'
import updateTagService from '../../Services/Queries/updateTagService'
import LoadingSpinner from '../Movie/Loading'
// import updateTagService from '../../Services/Queries/updateTagService'
// import DeleteTagService from '../../Services/Queries/DeleteTagService'

function CreateTag(props) {
  const [loadSpinner, setLoadSpinner] = useState(false)

  const [enteredValue, setEnteredValue] = useState(
    props.URLObject
      ? props.URLObject
      : {
          title_Te: '',
          title_En: '',
          tagURL: '',
          description_Te: '',
          description_En: '',
          mode: 'TFIDB',
          contentType: 'person',
          tagType: '',
        },
  )
  console.log(enteredValue, 'enteredValueenteredValue')
  const [selectedTab, setSelectedTab] = useState('Persons')

  // const [removeAddedTag, setRemoveAddedTag] = useState(false)
  const [tagslist, setTagslist] = useState([])
  // const [tagID, setTagID] = useState({})
  const [status, setStatus] = useState('')
  const [errors, setErrors] = useState({
    title_Te: '',
    title_En: '',
    tagURL: '',
    description_Te: '',
    description_En: '',
    mode: '',
    contentType: '',
    tagType: '',
  })

  const [isCreateDisabled, setIsCreateDisabled] = useState(true)
  // console.log(errors, 'isCreateDisabledisCreateDisabled')
  const handleSearch = (e, field) => {
    const { value } = e.target
    setEnteredValue(prevState => ({
      ...prevState,
      [field]: value,
    }))

    // Validation
    if (value.trim() === '') {
      setErrors(prevState => ({
        ...prevState,
        [field]: `${field.charAt(0).toUpperCase() + field.slice(1)} is required`,
      }))
    } else {
      setErrors(prevState => ({
        ...prevState,
        [field]: '',
      }))
    }

    const TagValues = {
      ...enteredValue,
      [field]: value,
    }

    if (TagValues.mode === 'TFIDB') {
      delete TagValues.tagType
    }

    // Check if all fields are filled
    const values = Object.values(TagValues)
    console.log(
      {
        ...enteredValue,
        [field]: value,
      },
      'valuesvaluesvaluesvalues',
    )

    for (let i = 0; i < values.length; i++) {
      if (typeof values[i] !== 'string') {
        values[i] = String(values[i])
      }
    }

    setIsCreateDisabled(values.some(val => String(val).trim() === ''))
  }

  const handleTypeChange = e => {
    setEnteredValue(prevState => ({
      ...prevState,
      mode: e.target.value,
    }))
  }

  const handleContentTypeChange = e => {
    setEnteredValue(prevState => ({
      ...prevState,
      contentType: e.target.value,
    }))
  }

  const handleTagTypeChange = e => {
    setEnteredValue(prevState => ({
      ...prevState,
      tagType: e.target.value,
    }))
  }

  console.log(enteredValue, 'inside create2')
  const createTag = async () => {
    setLoadSpinner(true)
    // Validation check
    // console.log('inside create')
    // const values = Object.values(enteredValue)
    // const keys = Object.keys(enteredValue)
    // let isValid = true

    const newErrors = {}
    // values.forEach((value, index) => {
    //   if (value.trim() === '') {
    //     isValid = false
    //     newErrors[keys[index]] = `${keys[index].charAt(0).toUpperCase() +
    //       keys[index].slice(1)} is required`
    //   }
    // })
    // console.log('inside create1')

    setErrors(newErrors)

    // if (isValid) {
    // Proceed with tag creation
    let loggedInUserHandle = ''
    const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''

    if (loggedInUserEmail) {
      const emailParams = loggedInUserEmail.split('@')
      loggedInUserHandle = '@' + emailParams[0]
    }

    const tagData = {
      ...enteredValue,
      tagType: enteredValue.mode === 'Admin' ? enteredValue.tagType : '',
      contentType: enteredValue.contentType,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }

    if (tagData.mode === 'TFIDB') {
      delete tagData.tagType
    }

    let tagResponse = []

    if (props.serviceType === 'editTag') {
      delete tagData.contentType
      delete tagData.mode
      delete tagData.tagURL
      tagResponse = await updateTagService(tagData)
    } else {
      tagResponse = await CreateTagService(tagData)
    }

    // console.log(tagResponse, 'tagResponsetagResponse')

    if (
      (tagResponse &&
        tagResponse.data &&
        tagResponse.data.createTag &&
        tagResponse.data.createTag.statusCode === '400') ||
      (tagResponse &&
        tagResponse.data &&
        tagResponse.data.updateTag &&
        tagResponse.data.updateTag.statusCode === '400')
    ) {
      // console.log('outsode else 400')

      if (props.serviceType === 'editTag') {
        setStatus(tagResponse.data.updateTag.statusMessage)
        toast.error(tagResponse.data.updateTag.statusMessage, ToastStyle)
      } else {
        setStatus(tagResponse.data.createTag.statusMessage)
        toast.error(tagResponse.data.createTag.statusMessage, ToastStyle)
      }
    } else {
      // console.log('insode else')
      setIsCreateDisabled(true)

      setTagslist([...tagslist, enteredValue])
      const value = {
        title_Te: '',
        title_En: '',
        tagURL: '',
        description_Te: '',
        description_En: '',
        mode: enteredValue.mode,
        contentType: enteredValue.contentType,
        tagType: '',
      }
      if (props.serviceType !== 'editTag') {
        setEnteredValue(value)
      }

      if (props.serviceType === 'editTag') {
        setStatus(tagResponse.data.updateTag.statusMessage)
        toast.success(tagResponse.data.updateTag.statusMessage, ToastStyle)
      } else {
        setStatus(tagResponse.data.createTag.statusMessage)
        toast.success(tagResponse.data.createTag.statusMessage, ToastStyle)
      }

      // }
    }

    setLoadSpinner(false)
  }

  useEffect(() => {
    if (props.serviceType === 'editTag') {
      console.log(props.URLObject, 'props.URLObjectprops.URLObject')
      setEnteredValue(props.URLObject)
    }
  }, [props])

  // const removeTag = item => {
  //   setRemoveAddedTag(true)
  //   setTagID(item)
  // }

  // const YesRemovetag = async () => {
  //   const deleteTag = await DeleteTagService({ PK: tagID.PK, SK: tagID.SK })
  //   console.log(deleteTag, 'deleteTagdeleteTag')
  //   toast.success(deleteTag.data.createTag.statusMessage, ToastStyle)
  //   const afterRemovingtag = tagslist.filter(item => item.PK !== tagID.PK)
  //   setTagslist(afterRemovingtag)
  //   setEnteredValue({
  //     title_Te: '',
  //     title_En: '',
  //     tagURL: '',
  //     description_Te: '',
  //     description_En: '',
  //     mode: '',
  //     contentType: '',
  //     tagType: '',
  //   })

  //   setRemoveAddedTag(false)
  //   setStatus('Tag deleted')
  // }

  // const NotRemovetag = () => {
  //   setRemoveAddedTag(false)
  //   setTagID({})
  // }
  const handleFilterChangeForTabs = item => {
    setSelectedTab(item.name)

    setEnteredValue({ ...enteredValue, contentType: item.Type, mode: item.Mode })
  }

  console.log(isCreateDisabled, 'isCreateDisabledisCreateDisabled')

  return (
    <div className=''>
      {loadSpinner && <LoadingSpinner />}

      <label className='mt-3 ml-3'>
        {/*  */}
        {props.serviceType === 'editTag' ? 'Edit Tag' : 'Create Tag'}
      </label>
      <div className='d-flex flex-column w-50'>
        {status && <div>{status}</div>}
        {/* <div className='border-1 border border-dark p-2 rounded tagContainer mb-2 d-flex gap-1'>
          {tagslist.map((item, index) => (
            <div key={index} className='border-1 border border-dark px-1 rounded tagsChips'>
              <span>{item.title_Te}</span>
              <span onClick={() => removeTag(item)}>
                <MdOutlineCancel />
              </span>
            </div>
          ))}
        </div> */}
      </div>
      {/* {removeAddedTag && (
        <div className='border-1 border border-dark p-2 rounded w-25  mb-2'>
          <label>Remove</label>
          <div className='d-flex gap-2'>
            <span onClick={() => YesRemovetag()} className='btn btn-primary'>
              Yes
            </span>
            <span onClick={() => NotRemovetag()} className='btn btn-primary'>
              No
            </span>
          </div>
        </div>
      )} */}
      <div className='d-flex flex-column gap-3 p-1 ml-2'>
        <div>
          <MoreInputs
            selectedTab={selectedTab}
            handleFilterChangeForTabs={handleFilterChangeForTabs}
            serviceType={props.serviceType}
            enteredValue={enteredValue && enteredValue}
            handleContentTypeChange={handleContentTypeChange}
            handleTypeChange={handleTypeChange}
            handleTagTypeChange={handleTagTypeChange}
          />
        </div>
        <div className='d-flex gap-4 flex-wrap'>
          <label className='labelWidth'>Tag Name Te</label>
          <input
            onPaste={e => handleSearch(e, 'title_Te')} // Add onPaste event
            className='p-2 rounded'
            name='title_Te'
            onChange={e => handleSearch(e, 'title_Te')}
            placeholder='Enter Tag Name ...'
            value={enteredValue && enteredValue.title_Te}
          ></input>
          {/* {errors.title_Te && <span className='error'>{errors.title_Te}</span>} */}
          <label className='labelWidth'>Tag Name En</label>

          <input
            name='title_En'
            onPaste={e => handleSearch(e, 'title_En')} // Add onPaste event
            className='p-2 rounded'
            onChange={e => handleSearch(e, 'title_En')}
            placeholder='Enter Tag Name ...'
            value={enteredValue && enteredValue.title_En}
          ></input>
          {/* {errors.title_En && <span className='error'>{errors.title_En}</span>} */}
        </div>

        <div className='d-flex gap-4 flex-wrap'>
          <label className='labelWidth'>Tag Desc Te</label>
          <input
            onPaste={e => handleSearch(e, 'description_Te')} // Add onPaste event
            name='description_Te'
            className='p-2 rounded'
            onChange={e => handleSearch(e, 'description_Te')}
            placeholder='Enter Tag Description ...'
            value={enteredValue && enteredValue.description_Te}
          ></input>
          {/* {errors.description_Te && <span className='error'>{errors.description_Te}</span>} */}
          <label className='labelWidth'>Tag Desc En</label>
          <input
            onPaste={e => handleSearch(e, 'description_En')}
            name='description_En'
            className='p-2 rounded'
            onChange={e => handleSearch(e, 'description_En')}
            placeholder='Enter Tag Description ...'
            value={enteredValue && enteredValue.description_En}
          ></input>
          {/* {errors.description_En && <span className='error'>{errors.description_En}</span>} */}
        </div>
        <div className='d-flex gap-4 flex-wrap'>
          <label className='labelWidth'>Tag URL</label>
          <div>
            <input
              onPaste={e => handleSearch(e, 'tagURL')}
              disabled={props.serviceType === 'editTag'}
              name='tagURL'
              className='p-2 rounded'
              onChange={e => handleSearch(e, 'tagURL')}
              placeholder='Enter Tag URL ...'
              value={enteredValue && enteredValue.tagURL}
            ></input>
            {!props.serviceType === 'editTag' && (
              <div className='text-danger'>
                Only English Link without special characters will be acceptable
              </div>
            )}
          </div>
          {/* {errors.tagURL && <span className='error'>{errors.tagURL}</span>} */}
        </div>
      </div>
      {Object.values(errors).some(error => error !== '') && (
        <div className='error' style={{ color: 'red', marginTop: '1rem' }}>
          {Object.values(errors)
            .filter(error => error)
            .join(', ')}
        </div>
      )}

      <button className={'btn btn-primary ml-3'} onClick={createTag} disabled={isCreateDisabled}>
        {props.serviceType === 'editTag' ? 'Update' : 'Create'}
      </button>
      {/* <div
        className={`${isCreateDisabled ? 'disable' : ''} btn btn-primary`}
        onClick={createTag}
        disabled={isCreateDisabled}
      >
        Create
      </div> */}
    </div>
  )
}

export default CreateTag
